import { render, staticRenderFns } from "./StudentForgetPassword.vue?vue&type=template&id=3eba8ec2&scoped=true&"
import script from "./StudentForgetPassword.vue?vue&type=script&lang=js&"
export * from "./StudentForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./StudentForgetPassword.vue?vue&type=style&index=0&id=3eba8ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eba8ec2",
  null
  
)

export default component.exports